import React from "react";
import { Icon } from "@mui/material";
import VuiBox from "components/ui/VuiBox";
import VuiTypography from "components/ui/VuiTypography";
import { DROPDOWN } from "../../utils/designTokens";

const DropdownButton = ({
  label,
  value,
  icon,
  onClick,
}) => {
  return (
    <VuiBox
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 1,
        flexShrink: { xs: 1, lg: 0 },
        minWidth: 0,
        width: { xs: "100%", lg: "auto" },
      }}
    >
      {label && (
        <VuiTypography
          variant={DROPDOWN.label.variant}
          color={DROPDOWN.label.color}
          fontWeight={DROPDOWN.label.fontWeight}
          sx={{
            flexShrink: 0,
            width: DROPDOWN.filterLabelColumnWidth,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {label}
        </VuiTypography>
      )}

      <VuiBox
        onClick={onClick}
        sx={{
          ...DROPDOWN.button,
          ...DROPDOWN.filterDropdownButton,
          background: DROPDOWN.background,
          backdropFilter: DROPDOWN.backdropFilter,
          border: DROPDOWN.border,
          borderRadius: DROPDOWN.borderRadius,
          "&:hover": {
            background: DROPDOWN.itemHover,
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
          },
        }}
      >
        {icon && (
          <Icon sx={{ color: "#fff", fontSize: "16px", mr: 0.5, flexShrink: 0 }}>
            {icon}
          </Icon>
        )}
        <VuiTypography
          color={DROPDOWN.textColor}
          sx={{ ...DROPDOWN.text, flex: 1, minWidth: 0 }}
        >
          {value}
        </VuiTypography>
      </VuiBox>
    </VuiBox>
  );
};

export default DropdownButton;
